import * as React from 'react';

const buyerIntentSignalSmall = (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_23086_12729)">
            <g style={{ mixBlendMode: 'multiply' }}>
                <path
                    d="M17.0657 5.03027C17.6561 6.22763 17.9879 7.57552 17.9879 9.00111C17.9879 13.965 13.9643 17.9887 9.00039 17.9887C8.76287 17.9887 8.52731 17.9794 8.29419 17.9613L11.9596 11.6827L9.64012 5.03076H17.0657V5.03027Z"
                    fill="url(#paint0_linear_23086_12729)"
                />
            </g>
            <path
                d="M5.19922 10.4374L11.9597 11.6817L8.29428 17.9603C5.68403 17.7575 3.38657 16.4394 1.8774 14.4826C0.708387 12.9651 0.0124512 11.064 0.0124512 9.00012C0.0124512 7.13028 0.583275 5.39387 1.56071 3.95605L5.19092 10.436L5.19922 10.4374Z"
                fill="url(#paint1_linear_23086_12729)"
            />
            <path
                d="M17.0654 5.02964H17.0649L9.6398 5.03013L5.19881 10.4378L5.19051 10.4363L1.5603 3.95641C3.17698 1.57586 5.90599 0.0124512 9.00007 0.0124512C12.5384 0.0124512 15.5992 2.05725 17.0654 5.02964Z"
                fill="url(#paint2_linear_23086_12729)"
            />
            <path
                d="M9.00062 12.4507C10.8889 12.4507 12.4197 10.9199 12.4197 9.03163C12.4197 7.14332 10.8889 5.61255 9.00062 5.61255C7.11232 5.61255 5.58154 7.14332 5.58154 9.03163C5.58154 10.9199 7.11232 12.4507 9.00062 12.4507Z"
                fill="url(#paint3_linear_23086_12729)"
            />
            <path
                d="M8.99991 12.7501C11.0534 12.7501 12.7181 11.0854 12.7181 9.03189C12.7181 6.9784 11.0534 5.31372 8.99991 5.31372C6.94642 5.31372 5.28174 6.9784 5.28174 9.03189C5.28174 11.0854 6.94642 12.7501 8.99991 12.7501Z"
                stroke="white"
                strokeWidth="1.36364"
                strokeMiterlimit="10"
            />
        </g>
        <defs>
            <linearGradient id="paint0_linear_23086_12729" x1="13.1411" y1="5.03027" x2="15.7721" y2="20.2841" gradientUnits="userSpaceOnUse">
                <stop stopColor="#7DC4FF" />
                <stop offset="1" stopColor="#FFE7AB" stopOpacity="0" />
            </linearGradient>
            <linearGradient id="paint1_linear_23086_12729" x1="10.0791" y1="15.6949" x2="-5.20927" y2="10.8649" gradientUnits="userSpaceOnUse">
                <stop stopColor="#2744FF" />
                <stop offset="1" stopColor="#B9D5FF" />
            </linearGradient>
            <linearGradient id="paint2_linear_23086_12729" x1="4.24989" y1="9.49988" x2="7.56961" y2="-6.69087" gradientUnits="userSpaceOnUse">
                <stop stopColor="#021ED4" />
                <stop offset="1" stopColor="#B9D5FF" />
            </linearGradient>
            <linearGradient id="paint3_linear_23086_12729" x1="10.5" y1="9.00012" x2="3.90477" y2="5.43026" gradientUnits="userSpaceOnUse">
                <stop stopColor="#BDD1E7" />
                <stop offset="1" stopColor="white" />
            </linearGradient>
            <clipPath id="clip0_23086_12729">
                <rect width="18" height="18" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

export default buyerIntentSignalSmall;
